/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { Button, Dropdown, Segment, Table, TextArea } from "semantic-ui-react";
import StringEntry from "../../datatypeComponents/StringEntry";
import PositiveIntEntry from "../../datatypeComponents/PositiveIntEntry";
import UnsignedIntEntry from "../../datatypeComponents/UnsignedIntEntry";
import DecimalEntry from "../../datatypeComponents/DecimalEntry";
import { useNavigate } from "react-router-dom";
import { changeFoiFocus } from "../../slices/foiOfFocus/foiOfFocusSlice";
import CodeableConceptEntry from "../../datatypeComponents/CodeableConceptEntry";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import AnnotationEntry from "../../datatypeComponents/AnnotationEntry";
import SEVCO, { comparativeStatisticsConceptSet, statisticTypeCodeableConceptSet } from "../../dictionaries/SEVCO";
import UCUM from "../../dictionaries/UCUM";
import { evidenceVariableDotHandlingValueSet } from "../EvidenceVariableResourceDisplay";
import submitComparativeEvidenceReportData from "../../functions/submitNewComparativeAPI";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import { systemChoices } from "../PicoClassifierModal";

const overallCertaintyRatingValueSet = [
    {
        "coding": [{
            "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
            "code": "high",
            "display": "High quality"
        }]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "moderate",
                "display": "Moderate quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "low",
                "display": "Low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "very-low",
                "display": "Very low quality"
            }
        ]
    }
];

const submitResources = async (apiToken, navigate, tableState, groupReferencesState, dispatch, introductionState, picoClassifiersState) => {

    let response = await submitComparativeEvidenceReportData(apiToken, tableState, groupReferencesState, introductionState, picoClassifiersState);
    if (response) {
        if (response.success && response.compositionFOI) {
            if (response.message) {
                alert("A ComparativeEvidenceReport was created but ..." + response.message);
            }
            navigate("/resources/Composition/" + response.compositionFOI);
            dispatch(changeFoiFocus(response.compositionFOI.toString()));
        } else {
            if (response.message) {
                alert(response.message);
            } else {
                alert("Failed response from server.");
            }
        }
    } else {
        alert("No response from server.");
    }
};

const pValueComparatorOptions = [
    { "key": "0", "value": "<", "text": "<" },
    { "key": "1", "value": "<=", "text": "<=" },
    { "key": "2", "value": ">", "text": ">" },
    { "key": "3", "value": ">=", "text": ">=" }
];

const ucumCommonCodeableConceptSet = UCUM.common.map(coding => {
    return { "coding": [coding] };
});

const TableRowEntry = ({ row, setTableState, rowIndex }) => {

    const [tableRowState, setTableRowState] = useState({});

    useEffect(() => {
        let startingRow = {
            "outcomeName": "",
            "outcomeDescription": "",
            "outcomeHandling": "",
            "observedOutcomeReference": "",
            "measureType": "",
            "unitOfMeasure": "",
            "numberAffectedIntervention": NaN,
            "numberAnalyzedIntervention": NaN,
            "valueWithIntervention": NaN,
            "numberAffectedComparator": NaN,
            "numberAnalyzedComparator": NaN,
            "valueWithComparator": NaN,
            "effectEstimateType": "",
            "effectEstimateValue": NaN,
            "effectEstimateUnit": "",
            "pValue": NaN,
            "pValueComparator": "",
            "lowerCI": NaN,
            "upperCI": NaN,
            "certainty": "",
            "note": ""
        };
        if (row.outcomeName) {
            startingRow.outcomeName = row.outcomeName;
        }
        if (row.outcomeDescription) {
            startingRow.outcomeDescription = row.outcomeDescription;
        }
        if (row.outcomeHandling) {
            startingRow.outcomeHandling = row.outcomeHandling;
        }
        if (row.observedOutcomeReference) {
            startingRow.observedOutcomeReference = row.observedOutcomeReference;
        }
        if (row.measureType) {
            startingRow.measureType = row.measureType;
        }
        if (row.unitOfMeasure) {
            startingRow.unitOfMeasure = row.unitOfMeasure;
        }
        if (row.effectEstimateType) {
            startingRow.effectEstimateType = row.effectEstimateType;
        }
        if (row.effectEstimateUnit) {
            startingRow.effectEstimateUnit = row.effectEstimateUnit;
        }
        if (row.pValueComparator) {
            startingRow.pValueComparator = row.pValueComparator;
        }
        if (!isNaN(row.numberAffectedIntervention)) {
            startingRow.numberAffectedIntervention = row.numberAffectedIntervention;
        }
        if (!isNaN(row.numberAnalyzedIntervention)) {
            startingRow.numberAnalyzedIntervention = row.numberAnalyzedIntervention;
        }
        if (!isNaN(row.valueWithIntervention)) {
            startingRow.valueWithIntervention = row.valueWithIntervention;
        }
        if (!isNaN(row.numberAffectedComparator)) {
            startingRow.numberAffectedComparator = row.numberAffectedComparator;
        }
        if (!isNaN(row.numberAnalyzedComparator)) {
            startingRow.numberAnalyzedComparator = row.numberAnalyzedComparator;
        }
        if (!isNaN(row.valueWithComparator)) {
            startingRow.valueWithComparator = row.valueWithComparator;
        }
        if (!isNaN(row.effectEstimateValue)) {
            startingRow.effectEstimateValue = row.effectEstimateValue;
        }
        if (!isNaN(row.pValue)) {
            startingRow.pValue = row.pValue;
        }
        if (!isNaN(row.lowerCI)) {
            startingRow.lowerCI = row.lowerCI;
        }
        if (!isNaN(row.upperCI)) {
            startingRow.upperCI = row.upperCI;
        }
        if (row.certainty) {
            startingRow.certainty = row.certainty;
        }
        if (row.note) {
            startingRow.note = row.note;
        }
        setTableRowState(startingRow);
    }, []);

    useEffect(() => {
        let riskWithIntervention = NaN;
        let riskWithComparator = NaN;
        if (!tableRowState.measureType?.coding || tableRowState.measureType.coding[0]?.code === "STATO:0000620") {
            if (!isNaN(tableRowState.numberAffectedIntervention) &&
                !isNaN(tableRowState.numberAnalyzedIntervention)) {
                riskWithIntervention = tableRowState.numberAffectedIntervention / tableRowState.numberAnalyzedIntervention;
                if (!isNaN(riskWithIntervention)) {
                    riskWithIntervention = parseFloat((riskWithIntervention * 100).toFixed(2));
                    setTableRowState(prevState => {
                        return {
                            ...prevState,
                            "measureType": {
                                "coding": [
                                    {
                                        "code": "STATO:0000620",
                                        "system": "https://fevir.net/sevco",
                                        "display": "risk"
                                    }
                                ]
                            },
                            "unitOfMeasure": {
                                "coding": [
                                    {
                                        "code": "%",
                                        "system": "http://unitsofmeasure.org",
                                        "display": "%"
                                    }
                                ]
                            },
                            "valueWithIntervention": riskWithIntervention
                        };
                    });
                }
            }
            if (!isNaN(tableRowState.numberAffectedComparator) &&
                !isNaN(tableRowState.numberAnalyzedComparator)) {
                riskWithComparator = tableRowState.numberAffectedComparator / tableRowState.numberAnalyzedComparator;
                if (!isNaN(riskWithComparator)) {
                    riskWithComparator = parseFloat((riskWithComparator * 100).toFixed(2));
                    setTableRowState(prevState => {
                        return {
                            ...prevState,
                            "measureType": {
                                "coding": [
                                    {
                                        "code": "STATO:0000620",
                                        "system": "https://fevir.net/sevco",
                                        "display": "risk"
                                    }
                                ]
                            },
                            "unitOfMeasure": {
                                "coding": [
                                    {
                                        "code": "%",
                                        "system": "http://unitsofmeasure.org",
                                        "display": "%"
                                    }
                                ]
                            },
                            "valueWithComparator": riskWithComparator
                        };
                    });
                }
            }
        }
    }, [
        tableRowState.numberAffectedIntervention, tableRowState.numberAnalyzedIntervention,
        tableRowState.numberAffectedComparator, tableRowState.numberAnalyzedComparator
    ]);

    useEffect(() => {
        if (Object.keys(tableRowState).length > 0) {
            let newRow = {
                "outcomeName": "",
                "outcomeDescription": "",
                "outcomeHandling": "",
                "observedOutcomeReference": "",
                "measureType": "",
                "unitOfMeasure": "",
                "numberAffectedIntervention": NaN,
                "numberAnalyzedIntervention": NaN,
                "valueWithIntervention": NaN,
                "numberAffectedComparator": NaN,
                "numberAnalyzedComparator": NaN,
                "valueWithComparator": NaN,
                "effectEstimateType": "",
                "effectEstimateValue": NaN,
                "effectEstimateUnit": "",
                "pValue": NaN,
                "pValueComparator": "",
                "lowerCI": NaN,
                "upperCI": NaN,
                "certainty": "",
                "note": ""
            };
            if (tableRowState.outcomeName) {
                newRow.outcomeName = tableRowState.outcomeName;
            }
            if (tableRowState.outcomeDescription) {
                newRow.outcomeDescription = tableRowState.outcomeDescription;
            }
            if (tableRowState.outcomeHandling) {
                newRow.outcomeHandling = tableRowState.outcomeHandling;
            }
            if (tableRowState.observedOutcomeReference) {
                newRow.observedOutcomeReference = tableRowState.observedOutcomeReference;
            }
            if (tableRowState.measureType) {
                newRow.measureType = tableRowState.measureType;
            }
            if (tableRowState.unitOfMeasure) {
                newRow.unitOfMeasure = tableRowState.unitOfMeasure;
            }
            if (tableRowState.effectEstimateType) {
                newRow.effectEstimateType = tableRowState.effectEstimateType;
            }
            if (tableRowState.effectEstimateUnit) {
                newRow.effectEstimateUnit = tableRowState.effectEstimateUnit;
            }
            if (!isNaN(tableRowState.numberAffectedIntervention)) {
                newRow.numberAffectedIntervention = tableRowState.numberAffectedIntervention;
            }
            if (!isNaN(tableRowState.numberAnalyzedIntervention)) {
                newRow.numberAnalyzedIntervention = tableRowState.numberAnalyzedIntervention;
            }
            if (!isNaN(tableRowState.valueWithIntervention)) {
                newRow.valueWithIntervention = tableRowState.valueWithIntervention;
            }
            if (!isNaN(tableRowState.numberAffectedComparator)) {
                newRow.numberAffectedComparator = tableRowState.numberAffectedComparator;
            }
            if (!isNaN(tableRowState.numberAnalyzedComparator)) {
                newRow.numberAnalyzedComparator = tableRowState.numberAnalyzedComparator;
            }
            if (!isNaN(tableRowState.valueWithComparator)) {
                newRow.valueWithComparator = tableRowState.valueWithComparator;
            }
            if (!isNaN(tableRowState.effectEstimateValue)) {
                newRow.effectEstimateValue = tableRowState.effectEstimateValue;
            }
            if (tableRowState.pValueComparator) {
                newRow.pValueComparator = tableRowState.pValueComparator;
            }
            if (!isNaN(tableRowState.pValue)) {
                newRow.pValue = tableRowState.pValue;
            }
            if (!isNaN(tableRowState.lowerCI)) {
                newRow.lowerCI = tableRowState.lowerCI;
            }
            if (!isNaN(tableRowState.upperCI)) {
                newRow.upperCI = tableRowState.upperCI;
            }
            if (tableRowState.certainty) {
                newRow.certainty = tableRowState.certainty;
            }
            if (tableRowState.note) {
                newRow.note = tableRowState.note;
            }
            setTableState(prevState => {
                let newTable = prevState;
                newTable[rowIndex] = newRow;
                return newTable;
            })
        }
    }, [tableRowState])

    return <>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <StringEntry elementName='outcomeName' fieldLabel='Outcome Name'
                startingValue={tableRowState.outcomeName}
                setResourceState={setTableRowState} />
            <StringEntry elementName='outcomeDescription' fieldLabel='Outcome Description'
                startingValue={tableRowState.outcomeDescription}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='outcomeHandling' fieldLabel='Outcome Handling'
                startingValue={tableRowState.outcomeHandling} setResourceState={setTableRowState}
                codeableConceptLevelValueSet={evidenceVariableDotHandlingValueSet} />
            <ReferenceEntry elementName='observedOutcomeReference' fieldLabel='Observed Outcome Reference'
                startingValue={tableRowState.observedOutcomeReference}
                startingResourceType="EvidenceVariable"
                referencedResourceTypes={["EvidenceVariable"]}
                enableCreation={true}
                setProfile={"VariableDefinition"}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <PositiveIntEntry elementName='numberAnalyzedIntervention' fieldLabel='Number Analyzed (Intervention)'
                startingValue={tableRowState.numberAnalyzedIntervention}
                setResourceState={setTableRowState} />
            <UnsignedIntEntry elementName='numberAffectedIntervention' fieldLabel='Number Affected (Intervention)'
                startingValue={tableRowState.numberAffectedIntervention}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='measureType' fieldLabel='Measure Type'
                startingValue={tableRowState.measureType}
                valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='valueWithIntervention' fieldLabel='Value with Intervention'
                startingValue={tableRowState.valueWithIntervention}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='unitOfMeasure' fieldLabel='Unit of Measure'
                startingValue={tableRowState.unitOfMeasure}
                valueSet={UCUM.common} codeableConceptLevelValueSet={ucumCommonCodeableConceptSet}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top", paddingLeft: "0px" }}>
            <PositiveIntEntry elementName='numberAnalyzedComparator' fieldLabel='Number Analyzed (Comparator)'
                startingValue={tableRowState.numberAnalyzedComparator}
                setResourceState={setTableRowState} />
            <UnsignedIntEntry elementName='numberAffectedComparator' fieldLabel='Number Affected (Comparator)'
                startingValue={tableRowState.numberAffectedComparator}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='measureType' fieldLabel='Measure Type'
                startingValue={tableRowState.measureType}
                valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='valueWithComparator' fieldLabel='Value with Comparator'
                startingValue={tableRowState.valueWithComparator}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='unitOfMeasure' fieldLabel='Unit of Measure'
                startingValue={tableRowState.unitOfMeasure}
                valueSet={UCUM.common} codeableConceptLevelValueSet={ucumCommonCodeableConceptSet}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top", whiteSpace: "pre-wrap" }}>
            <CodeableConceptEntry elementName='effectEstimateType' fieldLabel='Effect Estimate Type'
                startingValue={tableRowState.effectEstimateType}
                valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={comparativeStatisticsConceptSet}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='effectEstimateValue' fieldLabel='Effect Estimate Value'
                startingValue={tableRowState.effectEstimateValue}
                setResourceState={setTableRowState} />
            <CodeableConceptEntry elementName='effectEstimateUnit' fieldLabel='Effect Estimate Units'
                startingValue={tableRowState.effectEstimateUnit}
                valueSet={UCUM.common} codeableConceptLevelValueSet={ucumCommonCodeableConceptSet}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ align: "center", padding: "0px" }}>
            <Dropdown className="dropdownWithClearIconUpperRight"
                name="pValueComparator" placeholder="Comparator"
                closeOnChange selection clearable selectOnBlur={false} autoComplete='off'
                style={{ minWidth: "18%", width: "18%" }}
                options={pValueComparatorOptions}
                value={tableRowState.pValueComparator || ""}
                onChange={(e, data) => {
                    setTableRowState(prevState => { return { ...prevState, "pValueComparator": data.value } });
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <DecimalEntry elementName='pValue' fieldLabel='p Value'
                startingValue={tableRowState.pValue}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='lowerCI' fieldLabel='Lower Bound (95% CI)'
                startingValue={tableRowState.lowerCI}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='upperCI' fieldLabel='Upper Bound (95% CI)'
                startingValue={tableRowState.upperCI}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <CodeableConceptEntry elementName='certainty' fieldLabel='Certainty of evidence'
                startingValue={tableRowState.certainty}
                codeableConceptLevelValueSet={overallCertaintyRatingValueSet}
                setResourceState={setTableRowState} />
            <AnnotationEntry elementName='note' fieldLabel='Notes'
                startingValue={tableRowState.note}
                setResourceState={setTableRowState} />
        </Table.Cell>
    </>
}

// eslint-disable-next-line no-empty-pattern
const CreateComparativeEvidenceReport = ({ }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [groupReferencesState, setGroupReferencesState] = useState({
        "populationName": "", "populationDescription": "", "populationCount": NaN,
        "interventionName": "", "interventionDescription": "", "interventionCount": NaN,
        "comparatorName": "", "comparatorDescription": "", "comparatorCount": NaN
    });
    const [introductionState, setIntroductionState] = useState({
        "title": "",
        "sourceIntroduction": "", "sourceCitation": ""
    });
    const [tableState, setTableState] = useState([]);

    const [jsonEditingState, setJsonEditingState] = useState({ "jsonView": false });
    const [picoClassifiersState, setPicoClassifiersState] = useState({
        populationArray: [],
        interventionArray: [],
        comparatorArray: [],
        outcomeArray: []
    });

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {apiToken ?
                <>{jsonEditingState.jsonView ?
                    <div>
                        <TextArea style={{ minHeight: "400px", width: "65%" }}
                            value={jsonEditingState.fhirEntryStringRevised ||
                                (jsonEditingState.jsonString &&
                                    JSON.stringify(JSON.parse(jsonEditingState.jsonString), null, 2)) || ''}
                            onChange={(e) => {
                                setJsonEditingState(prevState => {
                                    return {
                                        ...prevState,
                                        "fhirEntryStringRevised": e.target.value
                                    }
                                });
                            }} />
                        <br />
                        <Button className="formButton positive" content="Submit" compact
                            onClick={() => {
                                try {
                                    let jsonString = jsonEditingState.fhirEntryStringRevised || jsonEditingState.jsonString;
                                    let json = JSON.parse(jsonString);
                                    submitResources(apiToken, navigate, json.results, json.groupings, dispatch, json.introduction, json.picoClassifiers);
                                } catch {
                                    alert("Unable to process the JSON.");
                                }
                            }} />
                        &nbsp;&nbsp;&nbsp;
                        <Button className="formButton" content="Edit Text View" compact
                            onClick={() => {
                                try {
                                    let jsonString = jsonEditingState.fhirEntryStringRevised || jsonEditingState.jsonString;
                                    let json = JSON.parse(jsonString);
                                    setIntroductionState(json.introduction);
                                    setGroupReferencesState(json.groupings);
                                    setTableState(json.results);
                                    setPicoClassifiersState(json.picoClassifiers);
                                    setJsonEditingState({ "jsonView": false })
                                } catch {
                                    alert("Unable to process the JSON.");
                                }
                            }} />
                    </div>
                    :
                    <div>
                        <StringEntry elementName='title' fieldLabel='Title'
                            startingValue={introductionState.title}
                            setResourceState={setIntroductionState} />
                        <StringEntry elementName='sourceCitation' fieldLabel='Source Citation'
                            startingValue={introductionState.sourceCitation}
                            setResourceState={setIntroductionState} />
                        <StringEntry elementName='sourceIntroduction' fieldLabel='Source Introduction'
                            startingValue={introductionState.sourceIntroduction}
                            setResourceState={setIntroductionState} />
                        <h3>Population Details</h3>
                        <StringEntry elementName='populationName' fieldLabel='Population Name'
                            startingValue={groupReferencesState.populationName}
                            setResourceState={setGroupReferencesState} />
                        <StringEntry elementName='populationDescription' fieldLabel='Population Description'
                            startingValue={groupReferencesState.populationDescription}
                            setResourceState={setGroupReferencesState} />
                        <PositiveIntEntry elementName='populationCount' fieldLabel='Population Count (Total Sample Size)'
                            startingValue={groupReferencesState.populationCount}
                            setResourceState={setGroupReferencesState} />
                        <h4>Classify the Population</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='populationArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Condition' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.populationArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <h3>Intervention Details</h3>
                        <StringEntry elementName='interventionName' fieldLabel='Intervention Name'
                            startingValue={groupReferencesState.interventionName}
                            setResourceState={setGroupReferencesState} />
                        <StringEntry elementName='interventionDescription' fieldLabel='Intervention Description'
                            startingValue={groupReferencesState.interventionDescription}
                            setResourceState={setGroupReferencesState} />
                        <PositiveIntEntry elementName='interventionCount' fieldLabel='Intervention Group Count'
                            startingValue={groupReferencesState.interventionCount}
                            setResourceState={setGroupReferencesState} />
                        <h4>Classify the Intervention</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='interventionArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Intervention' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.interventionArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <h3>Comparator Details</h3>
                        <StringEntry elementName='comparatorName' fieldLabel='Comparator Name'
                            startingValue={groupReferencesState.comparatorName}
                            setResourceState={setGroupReferencesState} />
                        <StringEntry elementName='comparatorDescription' fieldLabel='Comparator Description'
                            startingValue={groupReferencesState.comparatorDescription}
                            setResourceState={setGroupReferencesState} />
                        <PositiveIntEntry elementName='comparatorCount' fieldLabel='Comparator Group Count'
                            startingValue={groupReferencesState.comparatorCount}
                            setResourceState={setGroupReferencesState} />
                        <h4>Classify the Comparator</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='comparatorArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Comparator' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.comparatorArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Outcome</Table.HeaderCell>
                                    <Table.HeaderCell>Value with Intervention</Table.HeaderCell>
                                    <Table.HeaderCell>Value with Comparator</Table.HeaderCell>
                                    <Table.HeaderCell>Effect Estimate</Table.HeaderCell>
                                    <Table.HeaderCell>p-value, 95% CI</Table.HeaderCell>
                                    <Table.HeaderCell>Certainty/Notes</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {tableState?.length > 0 ?
                                    tableState.map((row, rowIndex) => {
                                        return <Table.Row key={rowIndex}>
                                            <TableRowEntry row={row} setTableState={setTableState}
                                                rowIndex={rowIndex} />
                                        </Table.Row>
                                    })
                                    :
                                    <Table.Row>
                                        <Table.Cell colSpan="6" style={{ textAlign: "center" }}>
                                            <h4>There are no table rows created yet.</h4>
                                        </Table.Cell>
                                    </Table.Row>
                                }
                                <Table.Row>
                                    <Table.Cell colSpan="6" style={{ textAlign: "right" }}>
                                        <Button className="formButton" content="Add Table Row"
                                            style={{ color: "#000000" }} compact
                                            onClick={() => {
                                                setTableState(prevState => {
                                                    return [...prevState, {
                                                        "outcomeName": "",
                                                        "outcomeDescription": "",
                                                        "outcomeHandling": "",
                                                        "observedOutcomeReference": "",
                                                        "measureType": "",
                                                        "unitOfMeasure": "",
                                                        "numberAffectedIntervention": NaN,
                                                        "numberAnalyzedIntervention": NaN,
                                                        "valueWithIntervention": NaN,
                                                        "numberAffectedComparator": NaN,
                                                        "numberAnalyzedComparator": NaN,
                                                        "valueWithComparator": NaN,
                                                        "effectEstimateType": "",
                                                        "effectEstimateValue": NaN,
                                                        "effectEstimateUnit": "",
                                                        "pValue": NaN,
                                                        "pValueComparator": "",
                                                        "lowerCI": NaN,
                                                        "upperCI": NaN,
                                                        "certainty": "",
                                                        "note": ""
                                                    }]
                                                });
                                            }} />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <h3>Classify the Outcome(s)</h3>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='outcomeArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Outcome' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.outcomeArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <br />
                        <Button className="formButton positive" content="Submit" compact
                            onClick={() => {
                                submitResources(apiToken, navigate, tableState, groupReferencesState, dispatch, introductionState, picoClassifiersState);
                            }} />
                        &nbsp;&nbsp;&nbsp;
                        <Button className="formButton" content="Edit JSON" compact
                            onClick={() => {
                                setJsonEditingState({
                                    "jsonView": true,
                                    "jsonString": JSON.stringify({
                                        "introduction": introductionState,
                                        "groupings": groupReferencesState,
                                        "results": tableState,
                                        "picoClassifiers": picoClassifiersState
                                    })
                                });
                            }} />
                    </div>
                }</>
                :
                <div>
                    <h1>Please log in to use this function.</h1>
                </div>
            }
        </Segment>
    </div>
};

export default CreateComparativeEvidenceReport;